<template>
    <span>
    <el-form label-position="top" v-loading="loading">
        <el-form-item label="Select a Template">
            <el-select v-model="data.job_board_landing_page_template_id" placeholder="Select one" @change="() => $emit('refresh')">
                <el-option
                        v-for="item in landing_page_template_list"
                        :key="item.id"
                        :label="item.label"
                        :value="item.id">
                </el-option>
            </el-select>

            <a  v-if="data.landing_page_template.id"
                @click.prevent="deleteTemplateDialog(data.landing_page_template.id)"
                href="#"
                style="margin-left: 30px; color: red;"
            >
                <i class="fa fa-times" style="padding-right: 5px"></i>Delete theme
            </a>

            <a  v-if="data.landing_page_template.id"
                @click.prevent="openAddJobsDialog()"
                href="#"
                style="margin-left: 30px;"
            >
                <i class="fa fa-list" style="padding-right: 5px"></i>Select jobs for this template
            </a>

            <div v-if="data.landing_page_template.id" style="display: block;">
                Template ID: <span style="font-weight:bold;">{{ data.landing_page_template.id }}</span>
            </div>
        </el-form-item>

        <jobs-picker
            :show="show_dialogs.add_jobs"
            :employer_id="props.job.employer_id"
            :exclude_job_id="props.job.job_id"
            @close="show_dialogs.add_jobs = false"
            v-model="template_jobs"
            v-on:input="setMultipleJobsTemplate($event)"
        ></jobs-picker>

        <template v-if="data.job_board_landing_page_template_id === null">
            <el-form-item label="New Template Name">
                <el-input v-model="form_data.name"></el-input>
            </el-form-item>

            <el-button
                type="primary"
                @click="createTemplate(props.job.pagination.nextId)"
                size="small"
            >
                Create Template
            </el-button>
        </template>
        <template v-else>

            <el-form-item label="Color">
                <el-color-picker v-model="data.landing_page_template.color"></el-color-picker>
            </el-form-item>

            <el-form-item label="Map Color">
                <el-color-picker v-model="data.landing_page_template.map_color"></el-color-picker>
            </el-form-item>

            <el-form-item label="Hero Image (min 1920 x 876px)">
                <el-upload
                        :multiple="false"
                        :action="uploadUrl"
                        list-type="picture-card"
                        :on-preview="handlePictureCardPreview"
                        :on-remove="x => handleRemove('hero', x)"
                        :on-success="x => imageUploaded('hero', x)"
                        :file-list="data.landing_page_template.hero"
                        :limit="1"
                    >
                    <i class="el-icon-plus"></i>
                </el-upload>
            </el-form-item>

            <el-form-item label="Hero Image Position">
                <el-select v-model="data.landing_page_template.hero_position" placeholder="Select one">
                    <el-option
                            v-for="item in position_options"
                            :key="item"
                            :label="item"
                            :value="item">
                    </el-option>
                </el-select>
            </el-form-item>

            <el-form-item label="Form Position">
                <el-select v-model="data.landing_page_template.form_position" placeholder="Select one">
                    <el-option
                            v-for="item in form_positions"
                            :key="item"
                            :label="item"
                            :value="item">
                    </el-option>
                </el-select>
            </el-form-item>

            <el-form-item label="Favicon (48 x 48px)">
                <el-upload
                        :multiple="false"
                        :action="uploadUrl"
                        list-type="picture-card"
                        :on-preview="handlePictureCardPreview"
                        :on-remove="x => handleRemove('favicon', x)"
                        :on-success="x => imageUploaded('favicon', x)"
                        :file-list="data.landing_page_template.favicon"
                        :limit="1"
                    >
                    <i class="el-icon-plus"></i>
                </el-upload>
            </el-form-item>

            <el-form-item label="Images (min 300 x 300px)">
                <el-upload
                        :multiple="true"
                        :action="uploadUrl"
                        list-type="picture-card"
                        :on-preview="handlePictureCardPreview"
                        :on-remove="x => handleRemove('images', x)"
                        :on-success="(response, file, fileList) => imageUploaded('images', response, file, fileList)"
                        :file-list="data.landing_page_template.images">
                    <i class="el-icon-plus"></i>
                </el-upload>
            </el-form-item>
            <el-form-item label="Custom CSS">
                <el-input
                        type="textarea"
                        :rows="3"
                        placeholder="Please enter the title claim"
                        v-model="data.landing_page_template.styles">
                </el-input>
            </el-form-item>
        </template>
    </el-form>

    <el-dialog :visible.sync="dialogVisible">
      <img width="100%" :src="dialogImageUrl" alt="">
    </el-dialog>
    </span>
</template>

<style>
    .el-upload-list--picture-card .el-upload-list__item-thumbnail {
        width: initial;
        height: initial;
        max-width: 100%;
        max-height: 100%;
    }
</style>

<script>
    import JobsPicker from "../../../../accounts/Job/vue/campaigns/jobs-picker";

    export default {
        components: {JobsPicker},
        props: [
            'data',
            'props',
            'landing_page_template_list',
        ],
        data() {
            return {
                loading: false,
                uploadUrl: this.$root.imageUploadUrl,
                dialogImageUrl: '',
                dialogVisible: false,
                position_options: [ 'left top', 'left center', 'left bottom', 'right top',
                    'right center', 'right bottom', 'center top', 'center center', 'center bottom'],
                form_positions: [ 'left', 'right' ],
                form_data: {
                    name: "",
                },
                template_jobs: [],
                show_dialogs: {
                    add_jobs: false
                },
            };
        },
        watch: {
            'data.landing_page_template.color'() {
                this.setStyles();
            },
            'data.landing_page_template.styles'() {
                this.setStyles();
            },
            'data.landing_page_template.hero_position'() {
                this.setStyles();
            },
            'data.landing_page_template.form_position'() {
                this.setStyles();
            },
        },
        methods: {
            createTemplate() {
                this.loading = true;

                axios.post(url(`/admin/job-board/landing-page-template/create`), {
                    job_id: this.props.job.job_id,
                    employer_id: this.props.job.employer_id,
                    name: this.form_data.name
                })
                    .then((response) => {
                        this.data.job_board_landing_page_template_id = response.data.landing_page_template.id;

                        this.$emit('refresh');

                        this.loading = false;
                    });
            },
            deleteTemplateDialog(templateId) {
                this.$confirm('Do you really want to delete theme "' + this.data.landing_page_template.name + '"?', 'Confirm delete', {
                    confirmButtonText: 'Delete',
                    cancelButtonText: 'Cancel',
                    type: 'warning'
                }).then(() => {
                    this.deleteTemplate(templateId);
                }).catch(() => {
                });
            },
            deleteTemplate(templateId) {
                this.loading = true;

                axios.post(url(`/admin/job-board/landing-page-template/delete`), {
                    job_id: this.props.job.job_id,
                    job_board_landing_page_template_id: templateId
                })
                    .then((response) => {
                        this.data.job_board_landing_page_template_id = response.data.job_board_landing_page_template_id;
                    }).finally(() => {
                        this.$emit('refresh');

                        this.loading = false;
                    })
            },
            handleRemove(type, file, fileList) {
                this.data.landing_page_template[type] = _.filter(this.data.landing_page_template[type], t => t.url !== file.url);

                this.setStyles();
            },
            handlePictureCardPreview(file) {
                this.dialogImageUrl = file.url;
                this.dialogVisible = true;
            },
            imageUploaded(type, response, file, fileList) {
                let url = response;

                let image = {
                    name: '',
                    url: url
                };

                if(fileList){
                    let index = _.indexOf(fileList, file);
                    fileList.splice( index, 1, image);
                    this.data.landing_page_template[type] = fileList;
                }
                else{
                    this.data.landing_page_template[type].push(image);
                }

                this.setStyles();
            },
            setStyles() {
                this.$emit('change');
            },
            openAddJobsDialog() {
                this.show_dialogs.add_jobs = true;
            },
            setMultipleJobsTemplate($event) {
                this.loading = true;

                axios.post(url(`/admin/job-board/landing-page-template/set-to-jobs`), {
                    job_ids: this.template_jobs,
                    job_board_landing_page_template_id: this.data.landing_page_template.id
                }).finally(() => {
                    this.$emit('refresh');

                    this.loading = false;
                })
            },
        }
    }
</script>
